module.exports = __webpack_public_path__ + "media/images/cart/route04-7f657746c59169cf9d7d1941cc774e02.gif";